"use client"

import React from "react"
import TextWithImage from "../shared/TextWithImage"

const AdvantagesSection = () => {
  return (
    <TextWithImage
      reverse
      id="advantages"
      label="MOTORATA"
      title="Wszystkie oferty oraz finansowania w jednym miejscu"
      text="Na naszej platformie znajdzeisz wiele ofert samochodów osobowych oraz dosatwczych prosto od dealarów, komisów oraz brokerów samochodowych. Możesz szybko dopasować swoje finansowanie, wybierając dowolną formę finansowania - leasing, pożyczkę leasingową lub kredyt."
      list={[
        "Samochody bezpośrednio od dostawców",
        "Informacje na temat dostępności pojazdów",
        "Szybki i bezpośredni kontakt z wystawiającymi",
      ]}
      image="/images/graphic-offers.png"
    />
  )
}

export default AdvantagesSection
